/**
 * Read JSON embedded in a <script type="application/json"> tag.
 *
 * Large project graphs (and team extent lists) used to be passed as Stimulus
 * data-* attributes. Chrome/Blink is much less tolerant of multi-megabyte
 * HTML attributes than Firefox, so the same project could fail to boot in
 * Chrome while working in Firefox. Script-tag payloads skip that limit.
 */
export function readJsonScript<T>(id: string, fallback: T): T {
  const el = document.getElementById(id)
  if (!el) return fallback
  const text = el.textContent
  if (text == null || text.trim() === "") return fallback
  try {
    return JSON.parse(text) as T
  } catch (err) {
    console.error(`Failed to parse JSON script #${id}`, err)
    return fallback
  }
}
